import type { vendorApiNames } from '../names';
import type {
  ApiKeyAuthentication,
  UsernamePasswordAuthentication,
} from './auth';
import type {
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

/**
 * CheckPoint API settings available from API
 */
export type PublicCheckPointApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['checkpoint']
> &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings & {
    domains: string[];
  };

/**
 * CheckPoint API settings available in backend
 */
export type CheckPointApiSettings = PublicCheckPointApiSettings &
  (ApiKeyAuthentication | UsernamePasswordAuthentication);

/**
 * CheckPoint API settings expected on API when updating
 */
export type UpdateCheckPointApiSettings = BaseUpdateVendorApiSettings<
  PublicCheckPointApiSettings,
  ApiKeyAuthentication | UsernamePasswordAuthentication
>;
